import { all, takeLatest, takeEvery } from 'redux-saga/effects';
import { types as modalsAnchorActions } from '@/bit/reducers/reducers.modals-reducer';
import {
  initAnchorModalListener,
  addModal,
} from '@/bit/sagas/sagas.modals-saga';
import { types as retargetingTypes } from '@/reducers/retargeting-reducer';
import { types as headerActions } from '@/bit/reducers/reducers.header-reducer';
import { types as mainActions } from '@/bit/reducers/reducers.main-reducer';
import { types as formBafTypes } from '@/reducers/form-baf-reducer';
import { types as formTvTypes } from '@/reducers/form-tv-reducer';
import { types as addressTypes } from '@/reducers/address-reducer';
import { types as appointmentTypes } from '@/reducers/appointment-reducer';
import { types as formAdditionalFiberTypes } from '@/reducers/form-additional-fiber-reducer';
import { types as formMobileLineTypes } from '@/reducers/form-mobile-line-reducer';
import { types as MiMovistarNoClientTypes } from '@/reducers/form-mi-movistar-no-client-reducer';
import { types as samTypes } from '@/reducers/sam-reducer';
import { checkCPAndSetZones } from '@/bit/sagas/sagas.main-saga';
import {
  getSearcherInfo,
  getRelatedPages,
} from '@/bit/sagas/sagas.header-saga';
import {
  retargeting,
  studentRetargeting,
} from './retargeting/retargeting-sagas';
import {
  initPurchaseAdditionalFiber,
  setInfoAdditionalFiber,
  checkoutAdditionalFiber,
  processOrderAdditionalFiber,
  sendPurchaseOtpAdditionalFiber,
  validatePurchaseOtpAdditionalFiber,
} from './additionalFiberForm';
import {
  initPurchaseMobileLine,
  setInfoMobileLine,
  checkoutMobileLine,
  processOrderMobileLine,
  sendPurchaseOtpMobileLine,
  sendPortabilityOtpMobileLine,
  validateAllOtpsMobileLine,
} from './mobileLineForm';
import {
  getHorizontalAddresses,
  getVerticalAddresses,
} from './address/address-sagas';
import {
  initPurchaseMiMovistarNoClient,
  setInfoMiMovistarNoClient,
  checkoutMiMovistarNoClient,
  processOrderMiMovistarNoClient,
  sendPurchaseOtpMiMovistarNoClient,
  sendPortabilityOtpMiMovistarNoClient,
  validateAllOtpsMiMovistarNoClient,
} from './miMovistarNoClientForm';
import {
  initPurchaseBaf,
  setInfoBaf,
  checkoutBaf,
  processOrderBaf,
  sendPurchaseOtpBaf,
  validatePurchaseOtpBaf,
} from './bafForm';
import {
  initPurchaseTv,
  checkoutTv,
  processOrderTv,
  sendPurchaseOtpTv,
  validatePurchaseOtpTv,
} from './tvForm';
import { getExtraAppointmentOptions } from './appointment/appointment-sagas';
import { getTestVersionSam } from './sam/get-test-version-sam';

function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    takeLatest(addressTypes.INIT_HORIZONTAL_ADDRESSES, getHorizontalAddresses),
    takeLatest(addressTypes.INIT_VERTICAL_ADDRESSES, getVerticalAddresses),
    /* BAF */
    takeLatest(formBafTypes.INIT_PURCHASE, initPurchaseBaf),
    takeLatest(formBafTypes.SET_INFO, setInfoBaf),
    takeLatest(formBafTypes.CHECKOUT_REQUEST, checkoutBaf),
    takeLatest(formBafTypes.PROCESS_ORDER, processOrderBaf),
    takeLatest(formBafTypes.SEND_PURCHASE_OTP, sendPurchaseOtpBaf),
    takeLatest(formBafTypes.VALIDATE_PURCHASE_OTP, validatePurchaseOtpBaf),
    takeLatest(formBafTypes.STUDENT_RETARGETING, studentRetargeting),
    /* TV */
    takeLatest(formTvTypes.INIT_PURCHASE, initPurchaseTv),
    takeLatest(formTvTypes.CHECKOUT_REQUEST, checkoutTv),
    takeLatest(formTvTypes.PROCESS_ORDER, processOrderTv),
    takeLatest(formTvTypes.SEND_PURCHASE_OTP, sendPurchaseOtpTv),
    takeLatest(formTvTypes.VALIDATE_PURCHASE_OTP, validatePurchaseOtpTv),
    /* ADDITIONAL FIBER */
    takeLatest(
      formAdditionalFiberTypes.INIT_PURCHASE,
      initPurchaseAdditionalFiber
    ),
    takeLatest(formAdditionalFiberTypes.SET_INFO, setInfoAdditionalFiber),
    takeLatest(
      formAdditionalFiberTypes.CHECKOUT_REQUEST,
      checkoutAdditionalFiber
    ),
    takeLatest(
      formAdditionalFiberTypes.PROCESS_ORDER,
      processOrderAdditionalFiber
    ),
    takeLatest(
      formAdditionalFiberTypes.SEND_PURCHASE_OTP,
      sendPurchaseOtpAdditionalFiber
    ),
    takeLatest(
      formAdditionalFiberTypes.VALIDATE_PURCHASE_OTP,
      validatePurchaseOtpAdditionalFiber
    ),
    /* MOBILE LINES */
    takeLatest(formMobileLineTypes.INIT_PURCHASE, initPurchaseMobileLine),
    takeLatest(formMobileLineTypes.SET_INFO, setInfoMobileLine),
    takeLatest(formMobileLineTypes.CHECKOUT_REQUEST, checkoutMobileLine),
    takeLatest(formMobileLineTypes.PROCESS_ORDER, processOrderMobileLine),
    takeLatest(
      formMobileLineTypes.SEND_PURCHASE_OTP,
      sendPurchaseOtpMobileLine
    ),
    takeEvery(
      formMobileLineTypes.SEND_PORTABILITY_OTP,
      sendPortabilityOtpMobileLine
    ),
    takeLatest(
      formMobileLineTypes.VALIDATE_ALL_OTPS,
      validateAllOtpsMobileLine
    ),
    /* MIMO NO CLIENT */
    takeLatest(
      MiMovistarNoClientTypes.INIT_PURCHASE,
      initPurchaseMiMovistarNoClient
    ),
    takeLatest(MiMovistarNoClientTypes.SET_INFO, setInfoMiMovistarNoClient),
    takeLatest(
      MiMovistarNoClientTypes.CHECKOUT_REQUEST,
      checkoutMiMovistarNoClient
    ),
    takeLatest(
      MiMovistarNoClientTypes.PROCESS_ORDER,
      processOrderMiMovistarNoClient
    ),
    takeLatest(
      MiMovistarNoClientTypes.SEND_PURCHASE_OTP,
      sendPurchaseOtpMiMovistarNoClient
    ),
    takeEvery(
      MiMovistarNoClientTypes.SEND_PORTABILITY_OTP,
      sendPortabilityOtpMiMovistarNoClient
    ),
    takeLatest(
      MiMovistarNoClientTypes.VALIDATE_ALL_OTPS,
      validateAllOtpsMiMovistarNoClient
    ),
    /* APPOINTMENT */
    takeLatest(
      appointmentTypes.GET_EXTRA_APPOINTMENT_OPTIONS,
      getExtraAppointmentOptions
    ),
    // RETARGETING
    takeLatest(retargetingTypes.SEND_RETARGETING, retargeting),
    // SAM
    takeLatest(samTypes.GET_TEST_VERSION_SAM, getTestVersionSam),
    /* opcionales */
    takeLatest(headerActions.GET_SEARCHER_INFO, getSearcherInfo),
    takeLatest(headerActions.GET_RELATED_PAGES, getRelatedPages),
    /* ### */
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
  ]);
}

export default rootSaga;
